import { I18N_COMMON_KEYS } from '../i18nCommonKeys';

export const enTranslation: Record<string, string> = {
  [I18N_COMMON_KEYS.OK]: 'OK',
  [I18N_COMMON_KEYS.CANCEL]: 'Cancel',
  [I18N_COMMON_KEYS.SAVE]: 'Save',
  [I18N_COMMON_KEYS.CLEAR]: 'Clear',
  [I18N_COMMON_KEYS.EXECUTE]: 'Execute',
  [I18N_COMMON_KEYS.CLOSE]: 'Close',
  [I18N_COMMON_KEYS.LOADING]: 'Loading...',
  [I18N_COMMON_KEYS.CONFIRM]: 'Confirm',
  [I18N_COMMON_KEYS.DELETE]: 'Delete',
  [I18N_COMMON_KEYS.EDIT]: 'Edit',
  [I18N_COMMON_KEYS.CREATE]: 'Create New',
  [I18N_COMMON_KEYS.BACK]: 'Back',
  [I18N_COMMON_KEYS.NEXT]: 'Next',
  [I18N_COMMON_KEYS.PREVIOUS]: 'Previous',
  [I18N_COMMON_KEYS.SEARCH]: 'Search',
  [I18N_COMMON_KEYS.RESET]: 'Reset',
  [I18N_COMMON_KEYS.UPLOAD]: 'Upload',
  [I18N_COMMON_KEYS.DOWNLOAD]: 'Download',

  [I18N_COMMON_KEYS.SUCCESS]: 'Success',
  [I18N_COMMON_KEYS.ERROR]: 'Error',
  [I18N_COMMON_KEYS.WARNING]: 'Warning',
  [I18N_COMMON_KEYS.INFO]: 'Information',
  [I18N_COMMON_KEYS.CONFIRMATION_TITLE]: 'Confirmation',
  [I18N_COMMON_KEYS.EXECUTION_WARNING]: 'Please be careful when executing the query.',
  [I18N_COMMON_KEYS.NOT_FOUND]: 'Not Found',

  [I18N_COMMON_KEYS.DIALOG_OK]: 'OK',
  [I18N_COMMON_KEYS.DIALOG_CANCEL]: 'Cancel',
  [I18N_COMMON_KEYS.DIALOG_CLOSE]: 'Close',
  [I18N_COMMON_KEYS.TOAST_GENERAL_ERROR]: 'An error occurred.',
  [I18N_COMMON_KEYS.TOAST_UPDATE_SUCCESS]: 'Updated successfully.',
};
